export enum SiteRFPDocumentSummarySortByParam {
  SiteName = 'siteName',
  RequiredDocs = 'requiredDocs',
  Status = 'status',
  SystemSize = 'systemSize',
  LastUpdated = 'lastUpdated',
  NTPEstimate = 'ntpEstimate',
}
